import classNames from 'classnames';
import { useGlobalModules } from 'contexts';
import styles from './productLabels.module.scss';

const ProductLabels = ({
  freeItemLabel,
  customLabel,
  productAttributes,
  attributeLabelTextColor,
  attributeLabelBackgroundColor,
}) => {
  const globalModules = useGlobalModules();
  const isFreeItemLoading = freeItemLabel === undefined;
  const topLabel = isFreeItemLoading ? null : freeItemLabel || customLabel;
  const hasAttributeLabel =
    productAttributes && productAttributes[0] && globalModules.settings?.productCard?.showLabel;

  const getAttributeLabelStyle = () => {
    const style = {};
    if (attributeLabelTextColor) style.color = attributeLabelTextColor;
    if (attributeLabelBackgroundColor) style.backgroundColor = attributeLabelBackgroundColor;
    return style;
  };

  return (
    <>
      {topLabel && (
        <div className={classNames(styles.label, styles.customLabel)}>
          <span>{topLabel}</span>
        </div>
      )}
      {hasAttributeLabel && (
        <div
          className={classNames(styles.label, styles.attributeLabel)}
          style={getAttributeLabelStyle()}
        >
          <span className={styles.attributeLabelText}>{productAttributes[0]}</span>
        </div>
      )}
    </>
  );
};

export default ProductLabels;
